import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// backdrops
import Registration from './images/backdrops/registration.jpg'
import RegistrationM from './images/backdrops/registrationP.jpg'
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceP.jpg'
import Countdown from './images/backdrops/countdown.jpg'
import CountdownM from './images/backdrops/countdownM.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/space.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/auditoriumP.jpg'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import Gallerium from './images/backdrops/gallery.jpg'
import GalleriumP from './images/backdrops/galleryP.jpg'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations

import closeRightGlassDoor from './images/lobbyEntry/glass_closedoor_right.png'
import openRightGlassDoor from './images/lobbyEntry/glass_opendoor_right.png'
import closeLeftWoodDoor from './images/lobbyEntry/wood_closedoor_left.png'
import openLeftWoodDoor from './images/lobbyEntry/wood_opendoor_left.png'
import InfoIcon from './images/lobbyEntry/infoIcon.png'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://revolutiont.herokuapp.com',
}

const prod = {
  apiUrl: 'https://revolutiont.herokuapp.com',
}

const API_KEYS = {
  amplitude: 'a8e35746ff9ddb44afb4284b76590f35',
}

const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2021,
  month: 11,
  day: 5,
  hour: 9,
  minute: 30,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  register: {
    landscape: Registration,
    portrait: RegistrationM,
  },
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,
  galleriumP: GalleriumP,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 20%;
    bottom: 17%;
    left: 1%;
    right: 35%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'auditorium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium1,
    entryOpenImage: openLeftWoodDoor,
    entryCloseImage: closeLeftWoodDoor,
    css: `
      top: 56.8%;
      left: 33.5%;
      right: 59%;
      bottom: 35%;
    `,
  },
  {
    id: 'gallerium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemand,
    entryOpenImage: openRightGlassDoor,
    entryCloseImage: closeRightGlassDoor,
    css: `
      top: 29.5%;
      left: 66.4%;
      right: 26%;
      bottom: 63.8%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: InfoIcon,
    css: `
      top: 74%;
      left: 32%;
      right: 70%;
      bottom: 40.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'The REVOLUTIoNT: 4.0 The Internet Of Nano-Things By NanoMalaysia Berhad',

  ...config,
}
